import Field from "../Field";

export default class HeatExchangerField extends Field {
    onChange = nextValue => {
        this.step.getField('quickStepSetup').setValue(null)
    }
}
